<template>
   <div id="footer-bar" class="footer-bar-1">
        <router-link to="/home">
            <i :class="'fa fa-home ' + ($route.path === '/home' ? 'color-red1-dark':'')"></i><span>Home</span>
        </router-link>
        <router-link to="/chat">
            <i :class="'fa fa-comments ' + ($route.path === '/chat' ? 'color-red1-dark':'')"></i><span>Chat</span>
        </router-link>
        <router-link to="/profile">
            <i :class="'fa fa-cog ' + ($route.path === '/profile' ? 'color-red1-dark':'')"></i><span>Profile</span>
        </router-link>
    </div>
</template>

<script>
export default {
    name: "FooterBar"
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300&display=swap');

i{
    font-family: 'Roboto', sans-serif;
    font-weight: 300;
    
}

</style>